export interface DestinationCountry {
  code: string;
  name: string;
  flag: string;
  requiresCpf: boolean;
  postalCodeLabel: string;
  stateLabel: string;
  shippingMultiplier: number; // Factor relative to standard South America baseline (1.0)
  shippingZone: string;
  surfaceAvailable: boolean;
  salAvailable: boolean;
  isDomesticJapan?: boolean;
}

export const DESTINATION_COUNTRIES: DestinationCountry[] = [
  { 
    code: 'BR', 
    name: 'Brasil', 
    flag: '🇧🇷', 
    requiresCpf: true, 
    postalCodeLabel: 'CEP (Busca Automática)', 
    stateLabel: 'Estado (UF)',
    shippingMultiplier: 1.0,
    shippingZone: 'Zona 3 (América do Sul)',
    surfaceAvailable: false,
    salAvailable: false
  },
  { 
    code: 'PT', 
    name: 'Portugal', 
    flag: '🇵🇹', 
    requiresCpf: false, 
    postalCodeLabel: 'Código Postal', 
    stateLabel: 'Distrito / Concelho',
    shippingMultiplier: 0.85,
    shippingZone: 'Zona 2 (Europa)',
    surfaceAvailable: true,
    salAvailable: true
  },
  { 
    code: 'US', 
    name: 'Estados Unidos', 
    flag: '🇺🇸', 
    requiresCpf: false, 
    postalCodeLabel: 'ZIP Code', 
    stateLabel: 'Estado (State)',
    shippingMultiplier: 0.88,
    shippingZone: 'Zona 2 (América do Norte)',
    surfaceAvailable: true,
    salAvailable: true
  },
  { 
    code: 'JP', 
    name: 'Japão', 
    flag: '🇯🇵', 
    requiresCpf: false, 
    postalCodeLabel: 'Código Postal (〒)', 
    stateLabel: 'Província (Prefecture)',
    shippingMultiplier: 0.25,
    shippingZone: 'Japão Doméstico (Sagawa / Yu-Pack)',
    surfaceAvailable: true,
    salAvailable: true,
    isDomesticJapan: true
  },
  { 
    code: 'ES', 
    name: 'Espanha', 
    flag: '🇪🇸', 
    requiresCpf: false, 
    postalCodeLabel: 'Código Postal', 
    stateLabel: 'Província / Região',
    shippingMultiplier: 0.85,
    shippingZone: 'Zona 2 (Europa)',
    surfaceAvailable: true,
    salAvailable: true
  },
  { 
    code: 'IT', 
    name: 'Itália', 
    flag: '🇮🇹', 
    requiresCpf: false, 
    postalCodeLabel: 'CAP (Codice Postale)', 
    stateLabel: 'Província',
    shippingMultiplier: 0.85,
    shippingZone: 'Zona 2 (Europa)',
    surfaceAvailable: true,
    salAvailable: true
  },
  { 
    code: 'GB', 
    name: 'Reino Unido', 
    flag: '🇬🇧', 
    requiresCpf: false, 
    postalCodeLabel: 'Postcode', 
    stateLabel: 'Condado / Região',
    shippingMultiplier: 0.85,
    shippingZone: 'Zona 2 (Europa)',
    surfaceAvailable: true,
    salAvailable: true
  },
  { 
    code: 'CA', 
    name: 'Canadá', 
    flag: '🇨🇦', 
    requiresCpf: false, 
    postalCodeLabel: 'Postal Code', 
    stateLabel: 'Província',
    shippingMultiplier: 0.88,
    shippingZone: 'Zona 2 (América do Norte)',
    surfaceAvailable: true,
    salAvailable: true
  },
  { 
    code: 'AO', 
    name: 'Angola', 
    flag: '🇦🇴', 
    requiresCpf: false, 
    postalCodeLabel: 'Código Postal', 
    stateLabel: 'Província',
    shippingMultiplier: 1.10,
    shippingZone: 'Zona 3 (África)',
    surfaceAvailable: false,
    salAvailable: false
  },
  { 
    code: 'MZ', 
    name: 'Moçambique', 
    flag: '🇲🇿', 
    requiresCpf: false, 
    postalCodeLabel: 'Código Postal', 
    stateLabel: 'Província',
    shippingMultiplier: 1.10,
    shippingZone: 'Zona 3 (África)',
    surfaceAvailable: false,
    salAvailable: false
  },
  { 
    code: 'AR', 
    name: 'Argentina', 
    flag: '🇦🇷', 
    requiresCpf: false, 
    postalCodeLabel: 'Código Postal', 
    stateLabel: 'Província',
    shippingMultiplier: 0.98,
    shippingZone: 'Zona 3 (América do Sul)',
    surfaceAvailable: false,
    salAvailable: false
  },
  { 
    code: 'UY', 
    name: 'Uruguai', 
    flag: '🇺🇾', 
    requiresCpf: false, 
    postalCodeLabel: 'Código Postal', 
    stateLabel: 'Departamento',
    shippingMultiplier: 0.98,
    shippingZone: 'Zona 3 (América do Sul)',
    surfaceAvailable: false,
    salAvailable: false
  },
  { 
    code: 'PY', 
    name: 'Paraguai', 
    flag: '🇵🇾', 
    requiresCpf: false, 
    postalCodeLabel: 'Código Postal', 
    stateLabel: 'Departamento',
    shippingMultiplier: 0.98,
    shippingZone: 'Zona 3 (América do Sul)',
    surfaceAvailable: false,
    salAvailable: false
  },
  { 
    code: 'CL', 
    name: 'Chile', 
    flag: '🇨🇱', 
    requiresCpf: false, 
    postalCodeLabel: 'Código Postal', 
    stateLabel: 'Região',
    shippingMultiplier: 0.98,
    shippingZone: 'Zona 3 (América do Sul)',
    surfaceAvailable: false,
    salAvailable: false
  },
  { 
    code: 'DE', 
    name: 'Alemanha', 
    flag: '🇩🇪', 
    requiresCpf: false, 
    postalCodeLabel: 'PLZ (Postleitzahl)', 
    stateLabel: 'Estado (Bundesland)',
    shippingMultiplier: 0.85,
    shippingZone: 'Zona 2 (Europa)',
    surfaceAvailable: true,
    salAvailable: true
  },
  { 
    code: 'FR', 
    name: 'França', 
    flag: '🇫🇷', 
    requiresCpf: false, 
    postalCodeLabel: 'Code Postal', 
    stateLabel: 'Região / Departamento',
    shippingMultiplier: 0.85,
    shippingZone: 'Zona 2 (Europa)',
    surfaceAvailable: true,
    salAvailable: true
  },
  { 
    code: 'AU', 
    name: 'Austrália', 
    flag: '🇦🇺', 
    requiresCpf: false, 
    postalCodeLabel: 'Postcode', 
    stateLabel: 'Estado',
    shippingMultiplier: 0.80,
    shippingZone: 'Zona 2 (Oceania)',
    surfaceAvailable: true,
    salAvailable: true
  },
  { 
    code: 'OTHER', 
    name: 'Outro País', 
    flag: '🌐', 
    requiresCpf: false, 
    postalCodeLabel: 'Postal / Zip Code', 
    stateLabel: 'Estado / Província',
    shippingMultiplier: 1.0,
    shippingZone: 'Zona Internacional Standard',
    surfaceAvailable: false,
    salAvailable: false
  }
];

export function getCountryInfo(countryName?: string): DestinationCountry {
  if (!countryName) return DESTINATION_COUNTRIES[0];
  const found = DESTINATION_COUNTRIES.find(c => c.name.toLowerCase() === countryName.toLowerCase() || c.code.toLowerCase() === countryName.toLowerCase());
  return found || DESTINATION_COUNTRIES[0];
}
